/** Coerces location refs (string id or `{ _id }`) to a storage-safe id string. */
export function normalizeLocationId(value) {
  if (!value) {
    return '';
  }
  if (typeof value === 'object' && value._id) {
    return String(value._id);
  }
  return String(value);
}

export function resolveLocationId(survey) {
  const fromStorage = localStorage.getItem('location');
  if (fromStorage) {
    return fromStorage;
  }

  const clientConnectLocation = normalizeLocationId(
    survey?.clientConnect?.location_id,
  );
  if (clientConnectLocation) {
    return clientConnectLocation;
  }

  const surveyLocations = survey?.location_id;
  if (Array.isArray(surveyLocations) && surveyLocations.length === 1) {
    return normalizeLocationId(surveyLocations[0]);
  }

  return '';
}
